import {hasTempAccessToken} from 'auth/token'
import {useObvioUser} from 'obvio/auth'
import React from 'react'
import styled from 'styled-components'

/**
 * Displays a message when the user is acting as a temporary team member.
 * i.e., When a support user access obvio as the user they are helping.
 *
 */
export default function TempAuthMessage() {
  const user = useObvioUser()

  if (!hasTempAccessToken()) {
    return null
  }

  return (
    <div>
      <MessageHolder>
        <span>
          You are currently acting as{' '}
          <strong>
            {' '}
            {user.first_name} {user.last_name} (${user.email})
          </strong>
        </span>
      </MessageHolder>
    </div>
  )
}

const MessageHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 35px;
  text-align: center;
  padding: 5px 0;
  background: #fa3e3e;
  color: white;
`
